export default function Day() {
  return <div>Day</div>
}
